// MODEL : instance of FieldFilter

define('app/filters/CompactFieldFilterView',['require','./AbstractFieldFilterView','./FieldFilterView','app/config/strings','glu/dialog','glu/util','hbs!./CompactFieldFilterView.hbs'],function(require) {
	'use strict';

	var AbstractFieldFilterView = require('./AbstractFieldFilterView'),
		FieldFilterView = require('./FieldFilterView'),
		strings = require('app/config/strings'),
		dialog = require('glu/dialog'),
		_ = require('glu/util'),
		tmpl = require('hbs!./CompactFieldFilterView.hbs');

	return AbstractFieldFilterView.extend({
		template: tmpl,

		events: {
			'click > .delete button': 'removeMe',
			'click .select': 'stopPropagation',
			'click .select input': 'selectFilter',
			'click': 'openEditFilterDialog'
		},

		initialize: function() {
			this.listenTo(this.model, 'change', this.render);
			this.listenTo(this.options.report, 'change', this.render);
		},

		onRender: function() {
			var self = this,
				report = this.options.report;

			if (report.getModelName() === strings.reportModelName) {
				var column = _.filter(report.get('columnCollection').models, function(obj) {
					if (obj.get('columnType') === 'SEGMENT') {
						return obj.get('segmentId') === self.model.get('fieldObject').get('id');
					} else if (obj.get('columnType') === 'FUNCTION') {
						return obj.get('function') === self.model.get('fieldObject').get('id');
					} else {
						return obj.get('fieldId') === self.model.getField().id;
					}
				})[0];

				// Remove all existing classes
				self.$el.removeClass('aggregate group dimension measure');

				if (column) {
					if (report.isGroupedAndAggregated()) {
						self.$el.addClass(column.get('aggregation') ? 'aggregate' : 'group');
					} else {
						self.$el.addClass(self.model.getField().isMeasure() ? 'measure' : 'dimension');
					}
				}
			}


			this.renderFilterControl();
		},

		renderFilterControl: function() {
			var control = this.createFilterControl();
			control.isReadOnly = true;
			this.$el.find('> .filter-control').replaceWith(control.render().$el);
			this.$el.toggleClass('is-invalid', !this.isValid());
		},

		fieldName: function() {
			return this.model.fieldName();
		},

		fieldQualifiedName: function() {
			return this.model.fieldQualifiedName();
		},

		id: function() {
			return this.model.cid;
		},

		operatorLabel: function() {
			return this.getFilterType().label;
		},

		stopPropagation: function(e) {
			e.stopPropagation();
		},

		removeMe: function(evt) {
			evt.preventDefault();
			evt.stopPropagation();
			this.model.remove();
			this.appBus.trigger('refresh');
		},

		selectFilter: function(e) {
			var self = this;

			e.stopPropagation();
			if (self.model.get('selected')) {
				self.model.set('selected', false, {
					silent: true
				});
			} else {
				self.model.set('selected', true, {
					silent: true
				});
			}
			this.options.report.trigger('change:selected');

			this.$el.find('input:checkbox').parent().removeClass('selected');
			this.$el.find('input:checkbox:checked').parent().addClass('selected');
		},

		openEditFilterDialog: function(e) {
			if (e) {
				e.preventDefault();
			}

			//make sure it is not part of a segment 
			if (!this.model.get('segmentId')) {
				var view = new FieldFilterView({
					model: this.model
				});
				dialog.open(view);
			}
		},

		isValid: function() {
			return this.model.isValid();
		},

		isSegment: function() {
			return !!this.model.get('segmentId');
		},

		measureOrDimension: function() {
			return this.model.getField().isMeasure() ? 'measure' : 'dimension';
		}
	});

});

